export class SimpleSearch {
  constructor(public data: any) { }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/model/simple-search.model.ts